export const SEARCHCHIPS = {
  customerSearch: {
    logonId: "Customer.LoginID",
    firstName: "Customer.FirstName",
    lastName: "Customer.LastName",
    email1: "Customer.EmailAddress",
    phone1: "Customer.PhoneNumber",
    address1: "Customer.StreetAddress",
    zipcode: "Customer.ZipCode",
    state: "Customer.State",
    country: "Customer.Country",
  } as {
    [key: string]: string;
  },
  orderSearch: {
    orderId: "OrderManagement.OrderNumber",
    logonId: "OrderManagement.CustomerLoginId",
    orderDateFrom: "OrderManagement.StartDate",
    orderDateTo: "OrderManagement.EndDate",
    firstName: "OrderManagement.FirstName",
    lastName: "OrderManagement.LastName",
    email: "OrderManagement.EmailAddress",
    phone: "OrderManagement.PhoneNumber",
    streetAddress1: "OrderManagement.StreetAddress",
    zipCode: "OrderManagement.ZipPostalCode",
    state: "OrderManagement.StateProvince",
    country: "OrderManagement.Country",
  } as {
    [key: string]: string;
  },
};
